import {Button, DatePicker, Flex, Form, Select, TimePicker} from "antd";
import TextArea from "antd/es/input/TextArea";
import React from "react";
import dayjs from "dayjs";

const TodoSubmitForm = ({handleSubmitTodo}) => {


    return (
        <div>
            <Form
                name="todoForm"
                onFinish={async (values) => {
                    handleSubmitTodo(values);
                }}
                layout={"vertical"}
                initialValues={{message: '', deadlineDate: dayjs(new Date()), deadlineTime: dayjs(new Date())}}
                style={{marginTop: '32px'}}
            >
                <Form.Item
                    name={"message"}
                    rules={[
                        {required: true, message: 'Poruka je obavezno polje!'},
                        {min: 5, message: 'Poruka ne smije biti kraća od 5 znakova.'},
                    ]}
                >
                    <TextArea rows={4} style={{borderColor: ''}}/>
                </Form.Item>

                <Form.Item
                    name={"deadlineDate"}
                    label={`Rok dovršetka zadatka:`}
                    rules={[
                        {
                            required: false,
                            message: "Rok dovršetka zadatka je obavezno polje!",
                        },
                    ]}
                >
                    <DatePicker
                        style={{width: "100%"}}
                        getValueProps={(e) => ({
                            value: e ? dayjs(e).add(1, "hour") : "",
                        })}
                        placeholder="Odaberite datum"
                        format={"DD.MM.YYYY."}
                        disabledTime={true}
                    />
                </Form.Item>
                <Form.Item
                    name={`deadlineTime`}
                    label={`Vrijeme dovršetka zadatka:`}
                    rules={[
                        {
                            required: false,
                            message: "Vrijeme dovršetka zadatka je obavezno polje!",
                        },
                    ]}
                >
                    <TimePicker
                        style={{width: '100%'}}
                        placeholder={"Vrijeme dovršetka zadatka"}
                        format={"HH:mm:ss"}
                    />
                </Form.Item>
                <Flex vertical>

                    <Button
                        htmlType="submit"
                        loading={false}
                        type="primary"
                    >
                        Spremi
                    </Button>
                </Flex>
            </Form>
        </div>
       );
}
export default TodoSubmitForm;